
import './App.css';
import { BrowserRouter,Route, Routes } from 'react-router-dom';
import Login from './Login';
import RegistroComercio from './RegistroComercio';
import EditComercio from './EditComercio';
import ComerciosTodos from './ComerciosTodos';
import ComerciosConsulta from './ComerciosConsulta';
import InscripcionesConsulta from './InscripcionesConsulta';
import Inscripciones from './Inscripciones';
import PanelComercios from './PanelComercios';
import MenuUcip from './MenuUcip';
import MenuCamaras from './MenuCamaras';
import MenuComercio from './MenuComercio';
import Muestra from './Muestra';

import NotFound from './NotFound';
import Mensaje from './Mensaje';
import Terminos from './Terminos';
import Grafico from './Grafico';
import Logos from './Logos';
import ComerciosAdheridos from './ComerciosAdheridos'; 
import Recuperacion from './Recuperacion';


import { useStore} from './store/comercioStore' ;

function App() {
  const { comercioId , asigna , tipo ,asignaTipo} = useStore();
  return (
  <>  
    {tipo === '2' ? (
    <BrowserRouter>
    <Routes>
    <Route path = '/' element ={ <Login/>}/>
    <Route path = '/login' element ={ <Login/>}/>
    <Route path = '/Comerciosconsulta' element ={ <ComerciosConsulta/>}/>
    <Route path = '/inscripciones/:id' element ={ <Inscripciones/>}/>  
    <Route path = '/inscripcionesconsulta' element ={ <InscripcionesConsulta/>}/> 
    <Route path = '/registrocomercios' element = {<RegistroComercio/>}/>
    <Route path = '/editcomercio' element = {<EditComercio/>}/>
    <Route path = '/comerciosTodos' element ={ <ComerciosTodos/>}/>
    <Route path = '*' element = {<NotFound/>}/>
    <Route path = '/menuucip' element = {<MenuUcip/>}/>
    <Route path = '/terminos' element ={ <Terminos/>}/>
    <Route path = '/grafico' element ={ <Grafico/>}/>
    <Route path = '/logos' element ={ <Logos/>}/>
    
    
    </Routes>
  </BrowserRouter>
    ): tipo === '1' ?(
      <BrowserRouter>
      <Routes>
      <Route path = '/' element ={ <Login/>}/>
      <Route path = '/login' element ={ <Login/>}/>
      <Route path = '/Comerciosconsulta' element ={ <ComerciosConsulta/>}/>
      <Route path = '/editcomercio' element = {<EditComercio/>}/>
      <Route path = '/inscripcionesconsulta' element ={ <InscripcionesConsulta/>}/> 
      <Route path = '/panelcomercios' element = {<PanelComercios/>}/>
      <Route path = '/menucomercio' element = {<MenuComercio/>}/>
      <Route path = '*' element = {<NotFound/>}/>
      <Route path = '/terminos' element ={ <Terminos/>}/>
      
      </Routes>
    </BrowserRouter>
    ): tipo === '3' ?(
      <BrowserRouter>
      <Routes>
      <Route path = '/' element ={ <Login/>}/>
      <Route path = '/login' element ={ <Login/>}/>
      <Route path = '/Comerciosconsulta' element ={ <ComerciosConsulta/>}/>
      <Route path = '/editcomercio' element = {<EditComercio/>}/>
      <Route path = '/inscripcionesconsulta' element ={ <InscripcionesConsulta/>}/> 
      <Route path = '/panelcomercios' element = {<PanelComercios/>}/>
      <Route path = '/menucomercio' element = {<MenuComercio/>}/>
      <Route path = '*' element = {<NotFound/>}/>
      <Route path = '/menucamaras' element = {<MenuCamaras/>}/>
      </Routes>
    </BrowserRouter>
    ):
    (
      <BrowserRouter>
      <Routes>
      <Route path = '/' element ={ <Login/>}/>
      <Route path = '/mensaje' element ={ <Mensaje/>}/>
      <Route path = '/login' element ={ <Login/>}/>
      <Route path = '/registrocomercios' element = {<RegistroComercio/>}/>
      <Route path = '/inscripciones/:id' element ={ <Inscripciones/>}/>  
      <Route path = '*' element = {<NotFound/>}/>
      <Route path = '/terminos' element ={ <Terminos/>}/>
      <Route path = '/ComerciosAdheridos' element ={ <ComerciosAdheridos/>}/>
      <Route path = '/muestra' element ={ <Muestra/>}/>
      <Route path = '/recuperacion' element ={ <Recuperacion/>}/>
      </Routes>
    </BrowserRouter>
    )
    }
  </>
  );
}

export default App;

